<h2>
  {{ title }}
  <span *ngIf="model.Id" title="CHI Entity Group Id">- {{ model.Id }}</span>
  <span *ngIf="model.Name">- {{ model.Name }}</span>
</h2>
<hr />

<div class="divrel">
  <form
    (ngSubmit)="onSubmit()"
    #editFacilityForm="ngForm"
    class="editForm"
    novalidate
    [ngBusy]="busy"
    *ngIf="model"
  >
    <div class="row">
      <div class="col-md-12 tabs">
        <tabset #tabs>
          <tab heading="General">
            <app-entity-group-edit-general
              #general
              [model]="model"
              *ngIf="tabs.tabs[0].active === true"
            ></app-entity-group-edit-general>
          </tab>
          <tab heading="Fee Schedules" [disabled]="!model.Id">
            <app-entity-group-edit-feeschedules
              #feeSchedules
              *ngIf="tabs.tabs[1].active === true"
            ></app-entity-group-edit-feeschedules>
          </tab>
          <tab heading="Plans" [disabled]="!model.Id">
            <app-entity-group-edit-plans
              #plans
              *ngIf="tabs.tabs[2].active === true"
            ></app-entity-group-edit-plans>
          </tab>
          <tab heading="Providers" [disabled]="!model.Id">
            <app-entity-group-edit-providers
              #providers
              *ngIf="tabs.tabs[3].active === true"
            ></app-entity-group-edit-providers>
          </tab>
          <tab heading="Processing Rules" [disabled]="!model.Id">
            <app-entity-group-edit-processing-rules
              #processingRules
              *ngIf="tabs.tabs[4].active === true"
            ></app-entity-group-edit-processing-rules>
          </tab>
          <tab heading="Configs" [disabled]="!model.Id">
            <app-entity-group-edit-configs
              #configs
              *ngIf="tabs.tabs[5].active === true"
            ></app-entity-group-edit-configs>
          </tab>
        </tabset>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 text-right">
        <button type="submit" class="btn btn-success" *ngIf="tabs.tabs[0].active === true">
          Save
        </button>
        <button class="btn btn-default" type="button" (click)="backToList()">Back to list</button>
      </div>
    </div>
  </form>
</div>
